module.exports = __webpack_public_path__ + "img/Employer Seeding Infographic.e79c83b8.png";